module.exports = __webpack_public_path__ + "img/WechatIMG336.56dcfadb.png";